var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_2",
    "data-name": "katman 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.68 22.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_1",
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#1d1d1b",
    strokeWidth: 0,
    width: 22.68,
    height: 22.68
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/MAN.fae2ceee6b553253094facbfd277d3ec.svg";
export { ForwardRef as ReactComponent };